// src/utils/helpers.js new file that needs to be pushed

const DEBUG = process.env.REACT_APP_DEBUG === 'true' && process.env.NODE_ENV === 'development';

export const log = (msg, data) => {
  if (DEBUG) {
    console.log(`[DEBUG] ${msg}`, data);
  }
};

export const sanitizeString = (str) => {
  if (typeof str !== 'string') return '';
  return str
    .replace(/[<>"'`]/g, '')
    .trim()
    .slice(0, 100);
};

export const getDisplayError = (error, context = '') => {
  const errorMap = {
    'auth': 'Authentication failed. Please log in again.',
    'dashboard': 'Unable to load dashboard. Please refresh and try again.',
    'payment': 'Unable to process payment. Please try again.',
    'logout': 'Logout encountered an issue. Please clear your browser cookies manually if needed.',
    'default': 'An error occurred. Please try again.'
  };
  
  log(`Error [${context}]:`, error);
  return errorMap[context] || errorMap.default;
};

export const isValidUrl = (urlString) => {
  try {
    const url = new URL(urlString);
    return url.protocol === 'https:';
  } catch {
    return false;
  }
};